import type { Router } from 'vue-router'
import { LocalNotifications } from '@capacitor/local-notifications'
import { isNativePlatform } from '@/utils/platform'
import { resolveNotificationRoute } from '@/utils/notificationRoutes'

export function registerLocalNotificationTapHandler(router: Router): void {
  if (!isNativePlatform) return

  LocalNotifications.addListener('localNotificationActionPerformed', ({ notification }) => {
    const extra = (notification.extra ?? {}) as Record<string, string | undefined>
    const path = resolveNotificationRoute(extra)
    router.push(path)
  })
}
